var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRightArrowWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 12,
    viewBox: "0 0 6 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.21934 1.21934C0.359966 1.07889 0.550589 1 0.74934 1C0.948091 1 1.13871 1.07889 1.27934 1.21934L5.52934 5.46934C5.66979 5.60997 5.74868 5.80059 5.74868 5.99934C5.74868 6.19809 5.66979 6.38871 5.52934 6.52934L1.27934 10.7793C1.13716 10.9118 0.949119 10.9839 0.754818 10.9805C0.560517 10.9771 0.375132 10.8984 0.237719 10.761C0.100306 10.6235 0.0215929 10.4382 0.0181646 10.2439C0.0147364 10.0496 0.0868603 9.86152 0.21934 9.71934L3.93934 5.99934L0.21934 2.27934C0.0788899 2.13871 0 1.94809 0 1.74934C0 1.55059 0.0788899 1.35997 0.21934 1.21934Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrowWhite);
export default __webpack_public_path__ + "static/media/rightArrowWhite.d679327dcb7e60633fb78cfba48d2d96.svg";
export { ForwardRef as ReactComponent };